import { h } from 'preact'
import { isMobile } from '../../js/modules/utilities.js'

export const RegulierAutopromo = (props) => {
   try {
      const { advCanal, url, refZone, isAdvise, offerSpecificationCode, parentOfferSpecificationCode, alt, idc, images, adv_tracker, cacheKey } = props[0]

      let pdbIdc
      let cappingAdv
      if (isAdvise) {
         pdbIdc = offerSpecificationCode
         if (parentOfferSpecificationCode !== '') {
            pdbIdc += ',' + parentOfferSpecificationCode
         }
         cappingAdv = {
            'data-pdb-ta': adv_tracker,
            'data-adv-canal': advCanal,
            'data-adv-cappingdata': `{'m': '${offerSpecificationCode}','p': '${parentOfferSpecificationCode}','t': '${adv_tracker}'}`,
         }
      } else {
         pdbIdc = idc
      }

      if (isMobile()) {
         return (
            <a
               href={url}
               class="d-block overflow-hidden"
               data-pdb-zid={refZone}
               data-pdb-sc={isAdvise ? 'adv' : 'mpt'}
               data-pdb-idc={pdbIdc}
               data-pdb-vi={isAdvise ? `${images.urlImageResize}${images.img114}` : images.img2}
               {...cappingAdv}
               data-cache-key={cacheKey ? cacheKey : ''}
               data-oevent-category="foisonnement_foisonnement-push"
               data-oevent-action={alt}
               data-oevent-label={url}
               data-oevent-other={`{"track_refZ":"${refZone}"}`}
            >
               {isAdvise ? (
                  <picture>
                     <source srcset={`${images.urlImageResize}${images.img119}?format=480x520&saveas=webp`} media="(max-width: 479px)" />
                     <source srcset={`${images.urlImageResize}${images.img114}?format=600x240&saveas=webp`} media="(max-width: 599px)" />
                     <source srcset={`${images.urlImageResize}${images.img114}?format=720x300&saveas=webp`} media="(max-width: 719px)" />
                     <img src={`${images.urlImageResize}${images.img114}?format=900x360&saveas=webp`} alt={alt} class="h-100 img" loading="lazy" />
                  </picture>
               ) : (
                  <picture>
                     <source srcset={images.img1} media="(max-width: 479px)" />
                     <source srcset={images.img2} media="(max-width: 599px)" />
                     <source srcset={images.img3} media="(max-width: 719px)" />
                     <img src={images.img4} alt={alt} loading="lazy" class="h-100 img" />
                  </picture>
               )}
            </a>
         )
      } else {
         return (
            <a
               href={url}
               class="d-block overflow-hidden"
               data-pdb-zid={refZone}
               data-pdb-sc={isAdvise ? 'adv' : 'mpt'}
               data-pdb-idc={pdbIdc}
               data-pdb-vi={isAdvise ? `${images.urlImageResize}${images.img112}` : images.img2}
               {...cappingAdv}
               data-cache-key={cacheKey ? cacheKey : ''}
               data-oevent-category="foisonnement_foisonnement-push"
               data-oevent-action={alt}
               data-oevent-label={url}
               data-oevent-other={`{"track_refZ":"${refZone}"}`}
            >
               {isAdvise ? (
                  <picture>
                     <source srcset={`${images.urlImageResize}${images.img112}?format=x304&saveas=webp`} media="(max-width: 1199px)" />
                     <img src={`${images.urlImageResize}${images.img112}?format=x380&saveas=webp`} alt={alt} loading="lazy" />
                  </picture>
               ) : (
                  <picture>
                     <source srcset={images.img1} media="(max-width: 1199px)" />
                     <img src={images.img2} alt={alt} loading="lazy" />
                  </picture>
               )}
            </a>
         )
      }
   } catch (error) {
      console.error('regulier-autopromo.jsx', error)
   }
}
